import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'gesvatec-web';

  constructor(
    private router: Router,
    private readonly _translate: TranslateService,
  ) { }

  ngOnInit(): void {
    if (window.navigator.language.includes('es')) {
      this._translate.use('es-ES');
      this._translate.setDefaultLang('es-ES');
    } else {
      this._translate.use('en-US');
      this._translate.setDefaultLang('en-US');
    }
}
}
